import { Helmet } from 'react-helmet'
import { useNavigate } from 'react-router-dom'
import { APP } from '@/common/strings'
import { NAVIGATION_COPY } from '@/locales/en'
import { DetailListSection } from '@/common/ui/DetailListSection'
import { useCurrentAccount } from '@/account/useCurrentAccount'
import { getAccountPageEditViewRoute } from '@/common/navigation/accountRoutes'
import { useAccountDetailItems } from './model/useAccountDetailItems'
import { ActionableDetailItemRow } from './components/SettingsListItems'

export default function AccountDetailsView() {
    const navigate = useNavigate()
    const account = useCurrentAccount()

    const accountDetails = useAccountDetailItems({
        onAddTfn: () => navigate(getAccountPageEditViewRoute('tfn')),
    })
    const copy = NAVIGATION_COPY.account

    if (!account) {
        return null
    }

    return (
        <>
            <Helmet>
                <title>
                    {copy.pageTitle} | {APP.title}
                </title>
            </Helmet>

            <DetailListSection
                title={copy.accountDetailsTitle}
                items={accountDetails}
                renderItem={(item) => <ActionableDetailItemRow item={item} />}
            />
        </>
    )
}
